import { createSlice,PayloadAction } from '@reduxjs/toolkit';
import _get from 'lodash/get';
import _set from 'lodash/set';

import { ErrorTargetEnum } from './fileType';

const DOWNLOAD = 'download';

export interface DownloadErrorProps {
  errorTarget: ErrorTargetEnum;
  fileName: string;
  error?: string;
}

export interface DownloadState {
  // Map of ErrorTargetEnum to DownloadError
  downloadErrors: {
    [key: string]: DownloadErrorProps | null | undefined;
  };
}

const isSameError = (error: DownloadErrorProps, existingError: DownloadErrorProps | null | undefined) => {
  if (!existingError) return false;
  return error.fileName === existingError.fileName && error.error === existingError.error;
};

const initialState: DownloadState = { downloadErrors: {} };

const downloadSlice = createSlice({
  name: DOWNLOAD,
  initialState,
  reducers: {
    setDownloadError: (state: DownloadState, action: PayloadAction<DownloadErrorProps>) => {
      const error: DownloadErrorProps = action.payload;
      const existingError = _get(state.downloadErrors, error.errorTarget);
      if (!isSameError(error, existingError)) {
        _set(state.downloadErrors, error.errorTarget, error);
      }
    },
    clearDownloadError: (state: DownloadState, action: PayloadAction<ErrorTargetEnum>) => {
      const errorTarget = action.payload;
      _set(state.downloadErrors, errorTarget, null);
    }
  }
});

export const { setDownloadError, clearDownloadError } = downloadSlice.actions;

export default downloadSlice.reducer;